// extracted by mini-css-extract-plugin
module.exports = {"icon":"mobilemenudialog_icon__dZq3k","icon--hide":"mobilemenudialog_icon--hide__YKg8z","menu":"mobilemenudialog_menu__Rd77f"};